import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">Get In Touch</h2>
          <p className="text-lg text-navy-600 max-w-3xl mx-auto">
            Looking for dependable transportation across Dallas–Fort Worth? Contact InTimelog to discuss your requirements and schedule reliable, on-time service.
          </p>
        </div>

        {/* Contact Cards Grid */}
        <div className="max-w-6xl mx-auto">

          {/* Primary Contact - Phone */}
          <div className="mb-6">
            <div className="bg-gradient-to-br from-primary-600 to-navy-900 rounded-2xl p-6 md:p-8 text-center shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl mb-4">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white/90 mb-2">Call Us 24/7</h3>
              <a
                href="tel:+14695632674"
                className="inline-block text-3xl md:text-4xl font-bold text-white hover:scale-105 transition-transform duration-200 mb-2"
              >
                (469) 563-2674
              </a>
              <p className="text-primary-100">Available around the clock</p>
            </div>
          </div>

          {/* Secondary Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

            {/* Email */}
            <div className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition-colors duration-200 border-2 border-transparent hover:border-primary-200">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mb-4">
                <Mail className="w-6 h-6 text-primary-600" />
              </div>
              <h4 className="text-base font-bold text-navy-900 mb-2">Email</h4>
              <a
                href="mailto:support@intimelog.com"
                className="block text-primary-600 hover:text-primary-700 font-semibold mb-1"
              >
                support@intimelog.com
              </a>
              <p className="text-xs text-navy-600">Response within 1 hour</p>
            </div>

            {/* Location */}
            <div className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition-colors duration-200 border-2 border-transparent hover:border-primary-200">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mb-4">
                <MapPin className="w-6 h-6 text-primary-600" />
              </div>
              <h4 className="text-base font-bold text-navy-900 mb-2">Location</h4>
              <p className="text-navy-700 text-sm">Irving, TX 75039</p>
              <p className="text-navy-600 text-xs mt-1">We serve Dallas - Fort Worth metroplex</p>
            </div>

            {/* Hours */}
            <div className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition-colors duration-200 border-2 border-transparent hover:border-primary-200">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mb-4">
                <Clock className="w-6 h-6 text-primary-600" />
              </div>
              <h4 className="text-base font-bold text-navy-900 mb-2">Hours</h4>
              <div className="inline-block px-2.5 py-1 bg-green-100 text-green-700 rounded-md font-semibold text-xs mb-2">
                24/7 Available
              </div>
              <p className="text-xs text-navy-600">Office: Mon-Fri, 8AM-6PM</p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;